import { COLOR } from '../color';

export const DATA_BLOCK_THEME = {
    AIRCRAFT_MODEL_ICAO_CHARACTER_LIMIT: 4,
    ARRIVAL_BAR_IN_RANGE: COLOR.RED_05,
    ARRIVAL_BAR_OUT_OF_RANGE: COLOR.RED_02,
    ARRIVAL_BAR_SELECTED: COLOR.RED_09,
    BACKGROUND_IN_RANGE: COLOR.GREEN_05,
    BACKGROUND_OUT_OF_RANGE: COLOR.GREEN_02,
    BACKGROUND_SELECTED: COLOR.GREEN_09,
    DEPARTURE_BAR_IN_RANGE: COLOR.BLUE_05,
    DEPARTURE_BAR_OUT_OF_RANGE: COLOR.BLUE_02,
    DEPARTURE_BAR_SELECTED: COLOR.BLUE_09,
    HALF_HEIGHT: 16,
    HALF_WIDTH: 35,
    HAS_FILL: true,
    HEIGHT: 32,
    LEADER_DIRECTION: 360,
    LEADER_LENGTH_ADJUSTMENT_PIXELS: -10,
    LEADER_LENGTH_INCREMENT_PIXELS: 25,
    LEADER_LENGTH: 1,
    LEADER_PADDING_FROM_BLOCK_PX: 0,
    LEADER_PADDING_FROM_TARGET_PX: 0,
    SCRATCHPAD_CHARACTER_LIMIT: 3,
    TEXT_FONT: '10px monoOne, monospace',
    TEXT_IN_RANGE: COLOR.WHITE_05,
    TEXT_OUT_OF_RANGE: COLOR.WHITE_02,
    TEXT_SELECTED: COLOR.WHITE_09,
    WIDTH: 70
};
